module.exports = solid["data"];